import React from 'react';

const UserFilters = ({ searchTerm, setSearchTerm, onFilterClick, activeUsersCount, premiumUsersCount }) => {
  return (
    <>
      <div className="row mb-4 align-items-center">
        <div className="col-md-6">
          <h2 className="h4 mb-1">
            <i className="las la-users me-2 text-primary"></i>
            User Management
          </h2>
          <p className="text-muted mb-0">Manage all system users and their permissions</p>
        </div>
        <div className="col-md-6 text-end d-flex justify-content-end gap-2">
          <span
            className="badge bg-success bg-opacity-10 text-success fs-6 cursor-pointer"
            onClick={() => onFilterClick('active')}
            title="Click to filter Active users"
          >
            <i className="las la-user-check me-1"></i>
            {activeUsersCount || 0} Active
          </span>
          <span
            className="badge bg-warning bg-opacity-10 text-warning border border-warning fs-6 cursor-pointer"
            onClick={() => onFilterClick('premium')}
            title="Click to filter Premium users"
          >
            <i className="las la-crown me-1"></i>
            {premiumUsersCount || 0} Premium
          </span>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-6">
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0">
              <i className="las la-search text-muted"></i>
            </span>
            <input
              type="text"
              className="form-control border-start-0 ps-0"
              placeholder="Search users by name, email, or role..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="col-md-6 text-end">
          {/* Add User Button Placeholder - Passed from parent if needed, or included here */}
        </div>
      </div>
    </>
  );
};

export default UserFilters;
